import React from "react";
import Modal from "react-bootstrap/Modal";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import AnimatedLoader from "../../img/AnimatedLoader";
import { useTranslation } from 'react-i18next';
import { useAppContext } from "../AppContext";

function InfoModal({ state }) {
  const { t } = useTranslation();
  const { closeModal } = useAppContext();
  const content = state.isMarkdown && state.content  ? (
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{state.content}</ReactMarkdown>
  ) : state.content;

  return (
    <Modal show={state.show} onHide={closeModal} size={state?.modalSize || "lg"}>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>{state?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{content === 'loading' ? <AnimatedLoader width={250} height={250} /> : content}</Modal.Body>
      <Modal.Footer>
        <div
          className="white-border-btn cancel-btn"
          onClick={closeModal}
        >
          {t('cancel')}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default InfoModal;
